<template>
  <div>
  <form class="background d-flex" @keyup.enter.native="login" >
    <div
      class="Rectangle"
      id="login"
    >
      <!-- <div class="Rectangle" id="login" :style="{ 'min-height': `${formHeight}px` }"> @/assets/ezcms.png -->
      <img v-if="domain.includes('ezcrs') || domain.includes('ezcms') || domain == 'localhost'" style="width: 50%!important; margin-top: 10px!important; margin-bottom: 10px!important" class="one-inventory" src="@/assets/ezcms.png" alt />
      <p class="title">Extranet Login</p>
      <p v-if="loginFail" class="error-message-login">{{$t("_LOGIN.INVALID_ACCOUNT_INFO_MESSAGE")}}</p>
      <p v-if="isExpired" class="error-message-login">
        {{ $t("_LOGIN.SESSION_EXPIRED") }}
        <br />
        {{ $t("_LOGIN.SESSION_EXPIRED_MESSAGE") }}
      </p>
      <p v-if="notAccess" class="error-message-login">{{ $t("_LOGIN.HAS_NO_ACCESS") }}</p>
      <div>
        <label class="label-input">{{ $t("_LOGIN.USERNAME") }}</label>
        <input-text
          class="username"
          :placeholder="$t('_LOGIN.USERNAME')"
          :error="loginFail"
          :model.sync="user.username"
        >
          <div class="icon" slot="icon">
            <span v-if="loginFail" class="icon icon-Error icon--red"></span>
          </div>
        </input-text>
      </div>
      <div class="mb-5 pb-3">
        <label class="label-input">{{ $t("_LOGIN.PASSWORD") }}</label>
        <input-text
          class="password"
          :type="passwordInput.type"
          :placeholder="$t('_LOGIN.PASSWORD')"
          :error="loginFail"
          :model.sync="user.password"
        >
          <div class="icon" slot="icon">
            <span
              v-if="passwordInput.isShowed"
              class="icon icon-eye-disabled icon--grey--opacity"
              @click="toggleShowPassword"
            ></span>
            <span
              v-if="!passwordInput.isShowed"
              class="icon icon-eye icon--grey--opacity"
              @click="toggleShowPassword"
            ></span>
            <span v-if="loginFail" class="icon icon-Error icon--red"></span>
            <!-- <font-awesome-icon v-if="loginFail" icon="exclamation-circle" /> -->
          </div>
        </input-text>
      </div>
      <!-- <p class="forgot-password" id="show-modal" @click="show">
        {{
        $t("_LOGIN.FORGOT_PASSWORD")
        }}
      </p> -->
      <a class="login" :class="{ active: isReady }" @click="login">
        <span>
          {{ $t("_LOGIN.LOGIN") }}
          <v-icon>arrow_forward</v-icon>
        </span>
      </a>
      <!-- <a
        class="register"
        @mouseover="tip = registerUrl"
        @mouseout="tip = ''"
        @click="redirectToRegister"
      >
        {{
        $t("_LOGIN.REGISTER_NOW")
        }}
      </a> -->
      <!-- <p class="login-agent mb-0" style="text-transform: none">
        {{ $t("_LOGIN.LOOKING_AGENT") }}
        <span>
          <a
            :href="agentLoginUrl"
            class="tip ml-1"
            style="text-transform: none"
            @mouseover="tip = agentLoginUrl"
            @mouseout="tip = ''"
          >
            {{
            $t("_LOGIN.LOGIN_HERE")
            }}
          </a>
        </span>
      </p> -->
    </div>
    <span v-if="tip" class="ex-tip">{{tip}}</span>
    </form>
    <!-- template for the modal component -->
    <modal name="formatPass" id="resetPassword" transition="pop-out" :width="modalWidth" height="auto">
      <div class="box">
        <div class="box-part">
          <div class="partition">
            <div class="partition-title"><b>{{ $t("_LOGIN.ARE_YOU_FORGOT_PASSWORD") }}</b></div>
            <div class="partition-content">{{ $t("_LOGIN.ENTER_EMAIL_USERNAME") }}</div>
            <div class="partition-form"> 
              <form autocomplete="false" v-on:submit.prevent="checkIfRecaptchaVerified">
                	<div  v-if="emailnotfount" class="forgotFail " ><p>{{$t('_LOGIN.EMAIL_NOT_EXIST')}}!</p></div>
                  <div @click="emailnotfount = false">
                    <input-text
                      class="username_email"
                      :placeholder="$t('_LOGIN.EMAIL_USERNAME')"
                      :error="loginFail"
                      :model.sync="emailforgot"
                    >
                    </input-text>
                  </div>
                  <b-row class="vadiate-info">
                    <b-col class="text-left">
                      <span class="text-danger" v-if="emailforgot==''">
                      {{ $t('_LOGIN.EMAILADDRESS_ERROR_REQUIRED') }}
                      </span>
                    </b-col>
						      </b-row>
                  <!-- <template>
                    <vue-recaptcha  ref="recaptcha"
                      size="visible"
                      sitekey="6LfBzHEUAAAAAETurEi2S_JRuOTc1JoL9dkIGzF0"
                      @verify="markRecaptchaAsVerified"
                      @expired="onCaptchaExpired">    
                    </vue-recaptcha>
                    <b-row>
                      <b-col class="text-danger" style="font-size: 12px"><strong>{{ loginForm.pleaseTickRecaptchaMessage }}</strong></b-col>
                    </b-row>
                  </template> -->
              </form>
                <div class="row">
                  <div class="col-md-5">
                    <button type="button" class="btn btn-secondary cancel-btn" @click="close">
                      <i class="icon-Exit" style="font-size: 20px; position: relative; top: 4.2px;"></i>
                      <b style="font-size: 12px">{{$t('_LOGIN.CANCEL')}}</b>
                      </button>
                  </div>
                  <div class="col-md-7" style="padding-left: 0px;">
                    <button id="sendemail" @click="checkIfRecaptchaVerified" type="button" class="btn text-white btn-primary send-btn" :disabled="emailforgot === '' || emailforgot === null">
                      <div class="row">
                        <div class="text-center col" style="position: relative; bottom: 6px;">
                          <i class="icon-ic_email" style="font-size: 16px; position: relative; top: 2px;"></i> &nbsp; &nbsp; <b style="font-size: 12px">{{$t('_LOGIN.RESET')}}</b>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    	<modal name="forgotpassSuccess" height="auto" centered  hide-header hide-footer no-close-on-esc no-close-on-backdrop>
				<div class="text-center col" style="position: relative; bottom: 2px;">
					<p><i class="icon-ic_email" style="font-size: 80px"></i></p>
					<br>
					<p><b style="font-size: 18px">{{$t('_LOGIN.REQUEST_RESET_PASS_NOTICE')}}</b></p>
					<br>
					<p tyle="font-size: 12px; color: #808080">{{$t('_LOGIN.SEND_NEW_PASS')}}</p>
					<br>
					<p><b-button class="" @click="closeNotice" style="border-radius:8px;width: 174px;height:50px; background-color: #173d8f; color: #fff"> {{$t('CLOSE')}}</b-button></p>
				</div>
			</modal>
      <v-dialog  v-model="dialogEzID" persistent max-width="290" >
        <v-card>
          <v-card-title class="text-h5 pl-0 pr-0 txt-word-break">
            Tài khoản của bạn chưa được đăng ký
          </v-card-title>

          <v-card-text class="pl-0 pr-0 txt-word-break">
            Chúng tôi đang hoàn thành chức năng đăng nhập đồng bộ. <br>
            Vui lòng ấn xác nhận để đăng ký bên ezID
          </v-card-text>

          <v-card-actions class="pl-0 pr-0">
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="continuteLogin()"
            >
              {{$t('_LOGIN.CANCEL')}}
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="agreeEzId()"
            >
              {{$t('CONFIRM')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>
<style lang="scss" scoped>
.d-or{
  position: relative;
}
.txt-or{
  position: absolute;
    top: -9px;
    background: #144396;
    width: 30px;
    text-align: center;
    left: 47%;
}
</style>
<script>
import Input from "@/components/Utils/Input.vue";
import { authenticationService } from "@/_services/";
import { _validateEmail } from "@/_helpers/function.js";
import Vue from 'vue';
import VModal from 'vue-js-modal';
import VueRecaptcha from 'vue-recaptcha';
Vue.use(VModal);
const MODAL_WIDTH = 500;
const MODAL_HEIGHT = 376;
export default {
  components: {
    "input-text": Input,
    VueRecaptcha
  },
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      modalHeight: MODAL_HEIGHT,
      notAccess: null,
      formHeight: 0,
      scale: 1,
      passwordInput: {
        type: "password",
        isShowed: false
      },
      user: {
        username: "",
        password: ""
      },
      resetPass: {
        username: ""
      },
      loginFail: false,
      resetPassFail: false,
      isExpired: false,
      isClearExpiredMsg: 0,
      forgotPassUrl: location.origin + "/forgot-password",
      registerUrl: location.origin + "/register",
      agentLoginUrl: `https://ta.oneinventory.com?lang=${localStorage.getItem("systemLanguage")}`,
      tip: null,
			emailforgot: null,
			emailnotfount: false,
			loginForm: {
				recaptchaVerified: false,
				pleaseTickRecaptchaMessage: '',
			},
      dialogEzID: false,
      urlEzId: null,
      showPage: false,
    };
  },
  created() {
    
    // this.unit();
  },
  mounted() {
  },
  watch: {
    user: {
      handler(val) {
        this.notAccess = false;
        this.loginFail = false;
        this.resetPassFail = false;
      },
      deep: true
    },
    passwordInput: {
      handler(val) {
        this.passwordInput.type = val.isShowed ? "text" : "password";
      },
      deep: true
    },
    resetPassFail(value) {
      let form = document.getElementById("resetPassword");
      this.formHeight = form.offsetHeight;
    },
  },
  computed: {
    isReady() {
      return this.user.username && this.user.password;
    },
  },
  methods: {
    async unit() {
      await this.$oidc.signinRedirectCallback().then((resEzId) => {
        this.showPage = false;
          authenticationService.loginEzId(resEzId.access_token)
          .then(res => {
            if (res.responseCode != 0) {
              this.$oidc.signoutRedirect();
              alert(this.$t("_LOGIN.INVALID_ACCOUNT_INFO_MESSAGE"));
              return false;
            }
            if (!res.data.user.roles.length) {
              this.notAccess = true;
            }
            localStorage.setItem("jwt", res.data.token);
            this.$router.replace("generalInfo");
          });
          return;
      }).catch(e => {
       let vm = this;
        if (this.$route.params.isExpired) {
          this.isExpired = true;
        } else {
          this.isExpired = false;
        }
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("key");
        if (token) {
        this.loginToken(token);
        }
        //this.formHeight = window.innerHeight - 80;
        window.addEventListener("keyup", function(e) {
          if (e.keyCode == 13) {
            vm.login();
          }
        });
        if (urlParams.get("requestCode") && JSON.parse(localStorage.getItem("currentUser")) !== null) {
          this.$router.push({ name: "requestBookingDetail", params: { code: urlParams.get("requestCode") } });
        }
        this.showPage = true;
      });
    },
    agreeEzId() {
      this.dialogEzID = false;
      window.location = this.urlEzId;
    },
    loginEzId() {
      this.$oidc.signinRedirect();
    },
    continuteLogin() {
      this.dialogEzID = false;
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("requestCode")) {
        this.$router.push({ name: "requestBookingDetail", params: { code: urlParams.get("requestCode") } });
      } else {
        this.$router.replace("generalInfo");
      }
    },
    loginToken(e) {
      if (this.$route.name != "login") {
        return false;
      }
       let loader = this.$loading.show({
        loader: "dots"
      });
      authenticationService
        .loginToken(e)
        .then(res => {
          if (res.responseCode != 0) {
            loader.hide();
            return false;
          }
          if (!res.data.user.roles.length) {
            this.notAccess = true;
          }
          // localStorage.setItem("userInfo", JSON.stringify(res.data));
          localStorage.setItem("jwt", res.data.token);
          loader.hide();
          this.$router.push(
          { 
            name: "roomSales",
          });
        });
    },
    login(e) {
      if (this.$route.name != "login-admin") {
        return false;
      }
      if (!this.isReady) return false;
      // let loader = this.$loading.show({
      //   loader: "dots"
      // });
      authenticationService
        .login(this.user.username, this.user.password)
        .then(res => {
          if (res.responseCode != 0) {
            // loader.hide();
            this.loginFail = true;
            return false;
          }
          
          if (!res.data.user.roles.length) {
            this.notAccess = true;
          }
          this.$session.set('notify_expired', true); 
          localStorage.setItem("jwt", res.data.token);
          let localArrToken = [];
          localArrToken.push({
            hotel: res.data.hotel,
            token: res.data.token
          });
          localStorage.setItem("arrToken", JSON.stringify(localArrToken));
          if (!res.data.hotel) {
            this.$router.replace("chain-dashboard");
          } else {
            this.$router.push({
              name: "about",
              params: { hotelIdParam: res.data.hotel.id }
            });
          }
          
          
        });
    },
    toggleShowPassword() {
      this.passwordInput.isShowed = !this.passwordInput.isShowed;
    },
    redirectToRegister() {
      this.$router.replace("register");
    },
    show () {
      this.$modal.show('formatPass');
      this.emailnotfount = false;
			this.emailforgot = null;
      this.loginForm.recaptchaVerified = false;
      this.resetPassFail = false;
    },
    close () {
      this.$modal.hide('formatPass');
    },
    closeNotice (){
      this.$modal.hide('forgotpassSuccess');
    },
		markRecaptchaAsVerified(response) {
			this.loginForm.pleaseTickRecaptchaMessage = '';
			this.loginForm.recaptchaVerified = true;
    },		
    checkIfRecaptchaVerified() {
			// if (!this.loginForm.recaptchaVerified) {
			// 	this.loginForm.pleaseTickRecaptchaMessage = 'Vui lòng đánh dấu vào hộp xác minh';
			// 	return true;
      // }
      this.resetPass.username = this.emailforgot;
			authenticationService
        .forgotPassword(this.resetPass.username)
        .then(res => {
          if (res.responseCode == 0) {
            this.$modal.hide('formatPass');
            this.$modal.show('forgotpassSuccess');
          } else {
						this.emailnotfount = true;
					}
          // loader.hide();
        });
    },
  }
};
</script>